import { createTheme } from '@mui/material/styles';
import { deepPurple, red } from '@mui/material/colors';

const theme = createTheme({
    palette: {
    primary: deepPurple,
    error: red
    },
});

export default theme;